import HomePage from "./pages/Home";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}
